export default __webpack_public_path__ + "static/media/acre.82b902a1.svg";